/**
 * Chat deep links that start the customer's message for them. A screen sends
 * the customer to `/support?bookingId=<id>&topic=<key>`: the trip is pulled
 * up (Support's bookingId link) and the composer starts with the topic's
 * opening words, unsent, for the customer to finish. Only the keys below are
 * honored, so a link can't put arbitrary words in someone's message box.
 */

export const CHAT_TOPIC_DRAFTS = {
  // Trip page → Passengers → "Request a correction". Customers can't edit
  // travelers on a booked trip (migration 193); the concierge sends the fix
  // to the team (Help: "Fixing a name or date of birth on your booking").
  'traveler-correction': "I need to correct a traveler's details on this trip: ",
};

/** The opening words for `?topic=` in a query string, or '' for none / unknown. */
export function chatDraftFromSearch(search) {
  let topic = '';
  try {
    topic = new URLSearchParams(search || '').get('topic') || '';
  } catch {
    return '';
  }
  return Object.prototype.hasOwnProperty.call(CHAT_TOPIC_DRAFTS, topic) ? CHAT_TOPIC_DRAFTS[topic] : '';
}

/** '/support', with the trip pulled up and a topic's opening words when given. */
export function supportChatPath({ bookingId, topic } = {}) {
  const params = new URLSearchParams();
  if (bookingId) params.set('bookingId', bookingId);
  if (topic && Object.prototype.hasOwnProperty.call(CHAT_TOPIC_DRAFTS, topic)) params.set('topic', topic);
  const qs = params.toString();
  return qs ? `/support?${qs}` : '/support';
}
